async function browserIsWkWebview() {
    // Firefox/Chrome/Edge on iPadOS or iOS
    const isWkWebview = /.*(FxiOS|CriOS|EdgiOS).*/.test(navigator.userAgent);
    return isWkWebview;
}
export default browserIsWkWebview;
//# sourceMappingURL=is-wkwebview.js.map